var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('Header'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMainLayout),expression:"isShowMainLayout"}],staticClass:"main-layout__slot"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }